import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const postForm = (path, data) => {
  if (!BASE) return Promise.reject(new Error("Forms are offline right now."));
  return axios.post(`${BASE}/api${path}`, data);
};

export const errorMessage = (err) => {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return detail[0]?.msg?.replace("Value error, ", "") ?? "Please check the form.";
  return typeof detail === "string" ? detail : "Something went wrong. Please try again.";
};
